import angular from "angular";
import angularUIB from "angular-ui-bootstrap";
import core from "../core/core.module";
import train from "./train";
import trainForm from "./train-form/train-form";

angular
    .module('trainsControl.component', [angularUIB, train, core, trainForm])
    .component('trainsControl', {
        template: require('./trains-control.component.html'),
        controller: ['Train', 'notifier', '$uibModal', controller],
        bindings: {

        }
    });

function controller(Train, notifier, $uibModal) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.currentPage = 1;
        $ctrl.search = null;
        $ctrl.getList();
    };

    $ctrl.doFilter = function () {
        $ctrl.currentPage = 1;
        $ctrl.getList();
    };

    $ctrl.clearFilter = function () {
        $ctrl.currentPage = 1;
        $ctrl.search = null;
        $ctrl.getList();
    };

    $ctrl.getList = function () {
        Train
            .getList({
                currentPage: $ctrl.currentPage,
                search: $ctrl.search
            })
            .then(
                function (response) {
                    $ctrl.trains = response.data.trains;
                    $ctrl.totalCount = response.data.totalCount;
                },
                function (error) {
                    notifier.errorResponseNotify(error);
                }
            );
    };

    $ctrl.updateTrainType = function (train) {
        Train
            .update(train.number, {type: train.type})
            .then(
                function () {
                    notifier.successNotify('OK', 1000);
                },
                function (error) {
                    notifier.errorResponseNotify(error);
                }
            )
    };

    $ctrl.openForm = function (train) {
        $uibModal
            .open({
                component: 'trainForm',
                resolve: {
                    train: function () {
                        return train;
                    }
                }
            })
            .result
            .then(
                function (result) {
                    train.type = result.type;
                },
                function () {
                }
            );
    };

}

export default 'trainsControl.component';


// WEBPACK FOOTER //
// ./resources/assets/modules/trains-control/trains-control.component.js